(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('DatepickerDayController', ['DateService', DatepickerDayControllerFn]);

    /* Controller for a datepicker day  */
    function DatepickerDayControllerFn(DateService) {
        var vm = this;

        // current date
        vm.date = null;

        // navigate year 
        vm.navigateYear = navigateYear;
        // navigate month
        vm.navigateMonth = navigateMonth;

        // activate controller
        activate();

        // calculate year
        function navigateYear(direction) {
            if (vm.date !== undefined && vm.date !== null) {
                var year = vm.date.getFullYear() + direction * 1;
                vm.date.setFullYear(year);

                return vm.date;
            }
            return null;
        }

        // calculate month
        function navigateMonth(direction) {
            if (vm.date !== undefined && vm.date !== null) {
                var month = vm.date.getMonth() + direction * 1;
                vm.date.setMonth(month);

                return vm.date;
            }
            return null;
        }

        // do activation
        function activate() {
            vm.date = DateService.data.date;
        }
    }
})();